import { FC } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Title } from 'react-admin';
import Tiptap from '../../components/Tiptap';
export const Dashboard: FC = () => (
  <Card>
    <Title title="Дом" />
    <CardContent>
      <h1>Система управления Домом</h1>
      {/* <Tiptap /> */}
    </CardContent>
  </Card>
);
